import api from './client';

// Manual Statement Import API
export const manualStatementAPI = {
  listAccounts: () => api.get('/admin/manual-accounts'),
  createAccount: (formData) => api.post('/admin/manual-accounts', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  preview: (formData) => api.post('/admin/manual-statement/preview', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 60000,
  }),
  apply: (formData) => api.post('/admin/manual-statement/apply', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 120000,
  }),
  history: (accountId) => api.get('/admin/manual-statement/history', {
    params: accountId ? { account_id: accountId } : {},
  }),
  entityUuidBackfillPreview: () => api.get('/admin/manual-statement/entity-uuid-backfill-preview'),
  entityUuidBackfillApply: () => api.post('/admin/manual-statement/entity-uuid-backfill-apply'),
};
